export default "__VITE_ASSET__DUq94KIW__"